import { GenericObject } from '@cp/src/types/CommonConstans';
import { ReactNode } from 'react';
import { IPhoneNumberLimit } from '@cp/pages/CaseDetails/interfaces/CaseDetail.type';

export interface DropdownProps {
  /** Dropdown Options */
  options: Array<SelectPickerOptionProps> | undefined;
  /** Selected dropdown value */
  selectedValue?: SelectPickerValue;
  onSelectionChange: SelectionChangeType;
  placeholder?: string;
  containerClasses?: string;
  disabled?: boolean;
  error?: string | boolean;
  multiSelect?: boolean;
  defaultSelected?: SelectPickerOptionProps;
  arrowIconWidth?: number;
  arrowIconColor?: string;
  showSourceInSelectedValue?: boolean;
  showSourceAtBottom?: boolean;
  selectedLabels?: string;
  innerContainerStyle?: string;
  optionPosition?: OptionPosition;
  customOptionTemplate?: (option: string, optionInfo?: GenericObject) => ReactNode;
  placeholderColor?: string;
  showSolidArrow?: boolean;
  showEllipsisTooltip?: boolean;
  pickerContainerClasses?: string;
  showTextCursorOnDisabled?: boolean;
  tabIndexEnabled?: boolean;
  selectPickerItemClass?: string;
  titleClass?: string;
  showCancelOption?: boolean;
  showTitleInSelectedValue?: boolean;
  onRemoveFilters?: SelectionChangeType;
}

export enum OptionPosition {
  'top',
  'bottom'
}

export interface SelectPickerOptionProps {
  label: string;
  value: SelectPickerValue;
  source?: string | ReactNode;
  isDisabled?: boolean;
  rightAdornment?: ReactNode;
  dailyLimit?: IPhoneNumberLimit;
  hourlyLimit?: IPhoneNumberLimit;
}

export interface SelectPickerProps extends React.ComponentPropsWithoutRef<'div'> {
  /** List of options */
  options: Array<SelectPickerOptionProps>;
  /** Callback function gets called on selection change */
  onSelectionChange: (option: SelectPickerOptionProps) => void;
  /** Value for single select */
  selectedValue: Map<SelectPickerValue, SelectPickerOptionProps>;
  /** Array of values for multi select */
  // selectedValues?: Array<SelectPickerValue>;
  /** Toggles between single select and multi select */
  multiSelect?: boolean;
  wrapperClasses?: string;
  /** Message to be shown on no options */
  noOptionsMessage?: string;

  showSourceAtBottom?: boolean;
  optionPosition?: OptionPosition;
  customOptionTemplate?: (option: string) => ReactNode;
  selectPickerItemClass?: string;
}

export type SelectPickerValue = string | number;

export interface SelectPickerItemProps {
  selected: boolean;
  optionInfo: SelectPickerOptionProps;
  onOptionClick: (option: SelectPickerOptionProps) => void;
  multiSelect: boolean;
  showSourceAtBottom?: boolean;
  customOptionTemplate?: (option: string, optionInfo?: GenericObject) => ReactNode;
  selectPickerItemClass?: string;
}

export type SelectionChangeType = (
  option: SelectPickerOptionProps
) => void | ((option: SelectPickerOptionProps[]) => void);
